import { forwardRef, JSX, Ref, useImperativeHandle, useRef } from 'react'
import { useAuth } from '../../contexts/AuthProvider/useAuth';
import { getCSSVariableValue } from '../../commons/utils';
import { Dropdown } from 'react-bootstrap';
import styled from 'styled-components';
import { PDFViewer, PDFViewerHandler } from '../../components/PDFViewer';
import tinycolor from 'tinycolor2';

export interface PdfGeneratorHandler {
    generatePDF: (mode: Mode, params: any) => void
}

const Icon = styled.div`
    display: flex;
    margin-right: 5px;
    pointer-events: none;
    background-color: transparent;
    align-items: center;
    justify-content: center;
`

export type Mode = 'download' | 'view' | 'print'

export function createMenu(hint: string, color: string, icon: JSX.Element, onClick: (mode: Mode) => void, disabled?: boolean) {
    const _color = getCSSVariableValue(color ? color : 'var(--primary-color)');

    return (
        <Dropdown style={{ zIndex: 999 }} drop="up">
            <Dropdown.Toggle id="dropdown-basic"
                style={{
                    backgroundColor: _color,
                    borderColor: _color,
                    fontWeight: 600,
                    display: 'flex',
                    alignItems: 'center',
                    color: tinycolor(color).isDark() ? '#EAF4FD' : '#383838',
                    borderRadius: 50,
                }} className='p-1 me-1'>
                <Icon style={{ margin: 2 }}> {icon} </Icon>
            </Dropdown.Toggle>

            <Dropdown.Menu>
                <Dropdown.Item onClick={() => onClick('download')}>Baixar</Dropdown.Item>
                <Dropdown.Item onClick={() => onClick('view')}>Visualizar</Dropdown.Item>
                {/* <Dropdown.Item onClick={() => onClick('print')}>Imprimir</Dropdown.Item> */}
            </Dropdown.Menu>
        </Dropdown>
    );
}

interface PdfGeneratorProps {
    api: string
}

const PdfGenerator = (props: PdfGeneratorProps, ref: Ref<PdfGeneratorHandler>) => {
    const auth = useAuth();

    const refReport = useRef<PDFViewerHandler>(null)

    useImperativeHandle(ref, () => ({
        generatePDF,
    }))

    const generatePDF = async (mode: Mode, params: any) => {

        auth.post(props.api, params, undefined, { responseType: 'arraybuffer' }).then((resp: any) => {
            const blob = new Blob([resp.data], { type: 'application/pdf' });

            const fileName = resp.headers['content-disposition'].match(/filename="?([^"]+)"?/)[1];

            if (mode === 'download') {
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');

                link.href = url;
                link.download = fileName + '.pdf'
                link.click();

                window.URL.revokeObjectURL(url);
            } else if (mode === 'print') {
                const url = window.URL.createObjectURL(blob);
                const iframe = document.createElement('iframe')

                iframe.style.display = 'none'
                iframe.src = url
                document.body.appendChild(iframe)

                iframe.onload = () => {
                    iframe.contentWindow?.focus()
                    iframe.contentWindow?.print()
                    URL.revokeObjectURL(url)
                    document.body.removeChild(iframe)
                }
            } else {
                refReport.current?.openModal(blob)
            }
        })
    }

    return (
        <PDFViewer ref={refReport} />
    )
}

export default forwardRef(PdfGenerator)